import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Avatar, Checkbox, Grid, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb.js";
import DeactivateModal from "../../../components/Common/DeactivateModal.js";
import Label from "../../../components/Common/Label.js";
import LoadingDialog from "../../../components/Common/LoadingDialog.js";
import Notification from "../../../components/Common/Notification.js";
import SearchBar from "../../../components/Common/Searchbar.js";
import Table from "../../../components/Common/Table.js";
import TablePageControl from "../../../components/Common/TablePageControl.js";
import CustomButton from "../../../components/Form/CustomButton.js";
import RenderPopOverButton from "../../../components/Form/RenderPopOverButton.js";
import Header from "../../../components/VerticalLayout/Header.js";
import Helpers from "../../../helpers/helpers.js";
import { addNewUser, deleteUser, exportUserExcel, getGeneral, getUser, resetUserActionState, resetUserState, updateActivationUser, updateDepartmentUser, updateUser } from "../../../store/actions.js";
import CustomDrawer from "../../../components/Form/CustomDrawer.js";
import AppDialog from "../../../components/Common/AppDialog.js";
import AddUser from "./AddUser.js";
import moment from "moment";
import CustomSelect from "../../../components/Form/CustomSelect.js";
import ImportantNotice from "../../../components/Common/ImportantNotice.js";


const User = ({ exportExcel, userListing, addUser, editUser, roleList, departmentList, teamList, userPermission, editUserActivation, editUserDepartment, delUser }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setIsLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const [page, setPage] = useState(1);
  const [length, setLength] = useState("10");
  const [keyword, setSearch] = useState("");
  const [sort, setSorted] = useState("desc")
  const [sort_by, setSortBy] = useState("id")
  const [checkedAll, setCheckedAll] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [filterObject, setFilterObject] = useState({ status: "all", role_id: "" });
  const [addOpen, setAddOpen] = useState(false);
  const [deactivateOpen, setDeactivateOpen] = useState(false);
  const [changeDepartmentOpen, setChangeDepartmentOpen] = useState(false);
  const [suspendOpen, setSuspendOpen] = useState(false);
  const [currentDepartment, setCurrentDepartment] = useState("");
  const [creatable, setCreatable] = useState(true);
  const [editable, setEditable] = useState(true);
  const [activateable, setActivateable] = useState(true);
  const [deletable, setDeletable] = useState(true);
  const [exportable, setExportable] = useState(true);
  const [selectedTab, setSelectedTab] = useState("admin");
  const [error, setError] = useState("");
  const searchRef = useRef(keyword);

  useEffect(() => {
    dispatch(getGeneral());
    dispatch(resetUserState());
  }, [])

  useEffect(() => {
    if (userPermission?.length > 0) {
      userPermission?.includes("create-user") && setCreatable(true);
      userPermission?.includes("update-user") && setEditable(true);
      userPermission?.includes("delete-user") && setDeletable(true);
      userPermission?.includes("export-user") && setExportable(true);
      userPermission?.includes("activate-user") && setActivateable(true);
    }
  }, [userPermission])


  useEffect(() => {
    if (checkedAll) {
      let temp = userListing && userListing?.data?.data?.length > 0 ? userListing?.data?.data?.map((x, idx) => x?.id) : []
      setSelectedRow(temp)
    } else {
      setSelectedRow("")
    }

  }, [checkedAll]);

  const [notification, setNotification] = useState({
    open: false,
    msg: "",
    type: "success",
  });

  const getLengthPage = (page, length) => {
    setPage(page)
    setLength(length)
  }

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, length, sort, sort_by, selectedTab]);

  useEffect(() => {
    if (userListing?.data) {
      setIsLoading(false);
    }
  }, [userListing])

  useEffect(() => {
    if (addUser?.code === "success") {
      setIsLoading(false);
      setAddOpen(false);
      setError("");
      setSelectedRow("");
      setNotification({ open: true, msg: 'User has been added successfully', type: "success" });
      dispatch(resetUserActionState());
      initData();
    } else if (addUser?.code === "invalid_field") {
      setIsLoading(false);
      setError(addUser?.errors);
      setNotification({ open: true, msg: 'Invalid field', type: "error" });
      dispatch(resetUserActionState());
    }
  }, [addUser])

  useEffect(() => {
    if (editUser?.code === "success") {
      setIsLoading(false);
      setAddOpen(false);
      setError("");
      setSelectedRow("");
      setNotification({ open: true, msg: 'User has been updated successfully', type: "success" });
      dispatch(resetUserActionState());
      initData();
    } else if (editUser?.code === "invalid_field") {
      setIsLoading(false);
      setError(editUser?.errors);
      setNotification({ open: true, msg: 'Invalid field', type: "error" });
      dispatch(resetUserActionState());
    }
  }, [editUser])

  useEffect(() => {
    if (editUserActivation?.code === "success" || editUserDepartment?.code === "success") {
      setIsLoading(false);
      setAddOpen(false);
      setError("");
      setSelectedRow("");
      deactivateOpen && setDeactivateOpen(false);
      changeDepartmentOpen && setChangeDepartmentOpen(false);
      setNotification({ open: true, msg: 'User has been updated successfully', type: "success" });
      dispatch(resetUserActionState());
      initData();
    }
  }, [editUserActivation, editUserDepartment])

  useEffect(() => {
    if (delUser?.code === "success" || delUser?.code === "success") {
      setIsLoading(false);
      setSuspendOpen(false);
      setError("");
      setSelectedRow("");
      setNotification({ open: true, msg: 'User has been deleted successfully', type: "success" });
      dispatch(resetUserActionState());
      initData();
    }
  }, [delUser])

  useEffect(() => {
    searchRef.current = keyword || '';
  }, [keyword]);

  const resetFilter = () => {
    setFilterObject({
      status: "all",
      role_id: ""
    })
  }

  useEffect(() => {
    if (exportExcel?.code === "success") {
      setIsLoading(false)
      Helpers.handleDownloadExcelFile(exportExcel?.excel_base64, `${selectedTab}_listing`);
      dispatch(resetUserActionState());
    }

  }, [exportExcel]);

  useEffect(() => {
    if (checkedAll) {
      let temp = userListing && userListing?.length > 0 && userListing?.map((x, idx) => x?.id)
      setSelectedRow(temp)
    } else {
      setSelectedRow("")
    }

  }, [checkedAll]);

  const header = [
    {
      Header: "Staff",
      columnID: "id",
      accessor: (cellProps) => {
        const firstLetter = cellProps?.name ? cellProps?.name.charAt(0) : '-'
        return (
          <React.Fragment>
            <div className="d-flex">
              <Avatar src="">{firstLetter}</Avatar>
              <div className="mx-2">
                <div >{cellProps?.name || '-'}</div>
                <div className="subheader-2">{cellProps?.email || '-'}</div>
              </div>
            </div>
          </React.Fragment>
        )
      },
    },
    {
      Header: "Status",
      accessor: (cellProps) => {
        return (<><Label.GeneralStatusLabel label={cellProps?.status} list={Helpers.memberStatus} marginLeft={"0px"} /></>)
      },
    },

    {
      Header: "Created Since",
      columnID: "created_at",
      accessor: (cellProps) => {
        return (cellProps?.created ? moment(cellProps?.created).format("DD MMM YYYY") : "-")
      },
    },
    {
      Header: "Actions",
      accessor: (cellProps) => {
        const adminActionList = [
          { iconName: 'ri-pencil-line', label: 'Edit', color: '#454545', permission: editable, onClick: () => { setSelectedRow(cellProps); setAddOpen(true) } },
          { iconName: cellProps?.status === 'inactive' ? 'ri-eye-line' : 'ri-eye-off-line', label: cellProps?.status === 'inactive' ? 'Activate' : 'Deactivate', color: '#454545', permission: editable, onClick: () => { setSelectedRow(cellProps); setDeactivateOpen(true) } },
          { iconName: 'ri-forbid-line', label: 'Suspend User', color: '#F65151', permission: true, onClick: () => { setSelectedRow(cellProps); setSuspendOpen(true) } },
        ]
        return (
          <React.Fragment>
            <RenderPopOverButton
              items={adminActionList}
            />
          </React.Fragment>
        )
      },
      minWidth: 120,
      position: 'sticky',
    }
  ]

  const memberHeader = [
    {
      Header: "Staff",
      columnID: "id",
      accessor: (cellProps) => {
        const firstLetter = cellProps?.name ? cellProps?.name.charAt(0) : '-'
        return (
          <React.Fragment>
            <div className="d-flex">
              <Avatar src="">{firstLetter}</Avatar>
              <div className="mx-2">
                <div >{cellProps?.name || '-'}</div>
                <div className="subheader-2">{cellProps?.email || '-'}</div>
              </div>
            </div>
          </React.Fragment>
        )
      },
    },
    {
      Header: "Team",
      accessor: (cellProps) => {
        return (cellProps?.team_name || '-')
      },
    },
    {
      Header: "Department",
      accessor: (cellProps) => {
        return (cellProps?.department_name || '-')
      },
    },
    {
      Header: "Role",
      accessor: (cellProps) => {
        return (cellProps?.role_name || '-')
      },
    },
    {
      Header: "Status",
      accessor: (cellProps) => {
        return (<><Label.GeneralStatusLabel label={cellProps?.status} list={Helpers.memberStatus} marginLeft={"0px"} /></>)
      },
    },
    {
      Header: "Actions",
      accessor: (cellProps) => {
        const memberActionList = [
          { iconName: 'ri-pencil-line', label: 'Edit', color: '#454545', permission: editable, onClick: () => { setSelectedRow(cellProps); setAddOpen(true) } },
          { iconName: 'ri-arrow-left-right-line', label: 'Change Department', color: '#454545', permission: editable, onClick: () => { setSelectedRow(cellProps); setCurrentDepartment(cellProps?.department_id); setChangeDepartmentOpen(true) } },
          { iconName: cellProps?.status === 'inactive' ? 'ri-eye-line' : 'ri-eye-off-line', label: cellProps?.status === 'inactive' ? 'Activate' : 'Deactivate', color: '#454545', permission: editable, onClick: () => { setSelectedRow(cellProps); setDeactivateOpen(true) } },
          { iconName: 'ri-forbid-line', label: 'Suspend User', color: '#F65151', permission: true, onClick: () => { setSelectedRow(cellProps); setSuspendOpen(true) } },
        ]
        return (
          <React.Fragment>
            <RenderPopOverButton items={memberActionList} />
          </React.Fragment>
        )
      },
      minWidth: 120,
      position: 'sticky',
    }
  ]

  const filterList = [
    {
      label: "Sort By",
      data: Helpers?.teamSortByFilter,
      value: Helpers?.getSortStatus(sort, sort_by, 'name', 'created_at'),
      name: "sort_by",
      type: "radio",
      sortName1: "name",
      sortName2: "created_at",
    },
    {
      label: "Role",
      value: filterObject?.role_id || [],
      type: "radio",
      data: roleList ? roleList?.map((item) => ({ label: item.name, value: item.id })) : [],
      placeholder: "Select role",
      labelName: "name",
      valueName: "id",
      onChange: (e) => {
        setFilterObject({ ...filterObject, role_id: e })
      }
    },
    {
      label: "Team",
      value: filterObject?.team_id || [],
      type: "multiple_select",
      data: teamList || [],
      placeholder: "Select team",
      labelName: "name",
      valueName: "id",
      onChange: (e) => {
        setFilterObject({ ...filterObject, team_id: e })
      }
    },
    {
      label: "Department",
      value: filterObject?.department_id || [],
      type: "multiple_select",
      data: departmentList || [],
      placeholder: "Select department",
      labelName: "name",
      valueName: "id",
      onChange: (e) => {
        setFilterObject({ ...filterObject, department_id: e })
      }
    },
  ]

  const initData = () => {
    setIsLoading(true);
    let payload = {
      length: length || "",
      page: page || "",
      keyword: searchRef.current || "",
      department_id: filterObject?.department_id || "",
      team_id: filterObject?.team_id || "",
      sort: sort || "",
      sort_by: sort_by || "",
      type: selectedTab || "",
      role_id: filterObject?.role_id || "",
    }
    dispatch(getUser(payload));
  }


  const handleDelete = () => {
    setIsLoading(true);
    dispatch(deleteUser({ id: selectedRow?.id, userType: selectedTab }));
  }

  const handleDeactivate = () => {
    setIsLoading(true);
    dispatch(updateActivationUser({
      userType: selectedTab,
      id: selectedRow?.id,
      action: selectedRow?.status === 'active' ? 'deactivate' : 'activate'
    }))
  }

  const handleEditDepartment = () => {
    setIsLoading(true);
    dispatch(updateDepartmentUser({ id: selectedRow?.id, data: { department_id: currentDepartment } }));
  }


  const handleAddEditUser = (data) => {
    setIsLoading(true);
    if (Helpers.isNullOrEmpty(selectedRow)) {
      // add user
      dispatch(addNewUser({ userType: selectedTab, data: data }));
    } else {
      // edit user
      dispatch(updateUser({ id: selectedRow?.id, data: data, userType: selectedTab }));
    }
  }

  const applyFilter = (sort, sortBy) => {
    setSortBy(sortBy || "id");
    setSorted(sort || "desc");
    setPage(page === 1 ? '1' : 1);
    setDrawerOpen(false);
  }

  const handleSearch = (text) => {
    setSearch(text);
    setTimeout(() => {
      if (text === searchRef.current) {
        initData();
      }
    }, Helpers.searchInterval);
  }

  const handleExport = () => {
    setIsLoading(true);
    dispatch(exportUserExcel({
      keyword: searchRef.current || "",
      department_id: filterObject?.department_id || "",
      team_id: filterObject?.team_id || "",
      sort: sort || "",
      sort_by: sort_by || "",
      type: selectedTab || "",
      role_id: filterObject?.role_id || "",
    }))
  }

  const customToolsBar = () => {
    return (
      <Grid container spacing={2} mb={1} paddingBlock={1} justifyContent={"space-between"}>
        <Grid item xs={12} sm={6} className="d-flex align-items-end">
          <SearchBar
            value={keyword}
            setValue={(e) => handleSearch(e)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Stack gap={1} direction={{ xs: "column", sm: "row" }} className="d-flex justify-content-end">
            {exportable &&
              <CustomButton
                title={<><Icon icon={'ri-download-line'} style={{ marginRight: 5, color: '#525252CC' }} />Export</>}
                press={() => handleExport()}
                height={32}
                borderRadius={5}
                backgroundColor={'white'}
                textColor={'#000'}
                borderStyle={"1px solid #babcbe"}
              />}

            <CustomButton
              title={<><Icon icon={'ri-filter-3-line'} style={{ marginRight: 5, color: '#525252CC' }} />Filter</>}
              press={() => setDrawerOpen(true)}
              height={32}
              borderRadius={5}
              backgroundColor={'white'}
              textColor={'#000'}
              borderStyle={"1px solid #babcbe"}
            />

          </Stack>
        </Grid>

      </Grid>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <LoadingDialog open={loading || !userListing?.data} />
        <Container fluid>
          <Notification notification={notification} setNotification={setNotification} />
          <Header
            breadcrumb={<Breadcrumbs
              breadcrumbItems={[{ title: "Users", link: "#" },
              ]}
            />} >
            <CustomButton
              title={<><Icon icon={'ri-add-line'} style={{ marginRight: 5 }} />Create user</>}
              press={() => setAddOpen(true)}
              height={40}
            />
          </Header>
          {customToolsBar()}
          <div className="d-flex align-items-center mb-3">
            <div className={`tab-container ${selectedTab === "admin" ? "selected-tab-container" : ""}`} onClick={() => setSelectedTab("admin")}>Admin</div>
            <div className={`tab-container ${selectedTab === "member" ? "selected-tab-container" : ""}`} onClick={() => setSelectedTab("member")}>Manager & Agent</div>
          </div>
          <Table
            header={selectedTab === "admin" ? header : memberHeader}
            data={userListing?.data || []}
            pageSize={length}
            totalPage={userListing?.last_page || 10}
            getLengthPage={getLengthPage}
            customToolsBar={true}
            setCheckedAll={setCheckedAll}
            setSorted={setSorted}
            sort_by={sort_by}
            setSortBy={setSortBy}
            checkedAll={checkedAll}
            sort={sort}
            onTableRowClick={(row) => { navigate(`/settings-users/${selectedTab}/${row.id}`) }}
          />
          <TablePageControl
            from={userListing?.from || 1}
            to={userListing?.to || 1}
            total={userListing?.total || 1}
            length={length}
            setLength={setLength}
            page={page}
            setPage={setPage}
            totalPage={userListing?.last_page || 10}
          />
        </Container>
        <CustomDrawer
          filterData={filterList}
          drawerOpen={drawerOpen}
          anchor={"right"}
          applyFilter={applyFilter}
          resetFilter={resetFilter}
          setDrawerOpen={setDrawerOpen} />
        <AddUser
          open={addOpen}
          close={() => { setAddOpen(false); error && setError(''); setSelectedRow("") }}
          submit={(data) => handleAddEditUser(data)}
          userDetails={selectedRow}
          type={!selectedRow ? "add" : "edit"}
          userType={selectedTab}
          roleList={roleList}
          departmentList={departmentList}
          error={error}
        />
        <AppDialog
          open={suspendOpen}
          close={() => { setSuspendOpen(false); setSelectedRow("") }}
          title={"Suspend User"}
          cancelButton={true}
          positiveTitle={'Suspend'}
          positivePress={() => handleDelete()}
          positiveButtonStyle={{ backgroundColor: '#F65151', border: '1px solid #F65151' }}
          width={'40%'}
        >
          You are about to temporarily suspend this user’s access and their associated orders, quotations, and tasks.
          <ImportantNotice
            message={'Once suspended, this user will not be able to log in, and their active orders will be paused until reactivation.'}
            color={'#DBBD8799'}
            backgroundColor={'#FFCD7133'}
            iconColor={'#DBBD87'}
          />
          <div className="mt-2">Do you still want to proceed?</div>
        </AppDialog>
        <AppDialog
          open={changeDepartmentOpen}
          close={() => { setChangeDepartmentOpen(false); setSelectedRow(""); setCurrentDepartment("") }}
          title={"Change department"}
          cancelButton={true}
          positiveTitle={'Save'}
          positivePress={() => handleEditDepartment()}
          width={'40%'}
        >
          <CustomSelect
            title={"Department"}
            placeholder={"Select one"}
            values={currentDepartment}
            onChange={(e) => setCurrentDepartment(e)}
            data={departmentList || []}
            labelName={"name"}
            valueName={"id"}
          />
        </AppDialog>
        <DeactivateModal
          open={deactivateOpen}
          title={selectedRow?.status === 'active' ? "Deactivate" : "Activate"}
          message={selectedRow?.status === 'active' ?
            <div>
              <div>Once deactivated, the user will permanently lose access to the system until reactivated.</div>
              <div>All related records (orders, quotations, and tasks) will remain stored, but no new actions can be performed by this user.</div>
            </div> : ""}
          close={() => { setDeactivateOpen(false); setSelectedRow("") }}
          submit={() => handleDeactivate()}
          module={'user'}
        />
      </div>
    </React.Fragment>
  );
};

function mapStateToProps({ Login, General, User }) {
  return {
    userListing: User.userListing,
    addUser: User.addUser,
    editUser: User.editUser,
    delUser: User.delUser,
    editUserActivation: User.editUserActivation,
    editUserDepartment: User.editUserDepartment,
    userData: Login?.verifyAdmin?.user?.data,
    exportExcel: User.exportExcel,
    departmentList: General.department_list,
    roleList: General.role_list,
    teamList: General.team_list,
    userPermission: Login.permissionArry,
  };
}


export default connect(mapStateToProps)(User);
